import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit {


  @Input() reportDocInfo;
 
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {

    //console.log("ReportDetailsComponent");
    //console.log(this.reportDocInfo);
  }

}
